var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container4"},[_c('h3',[_vm._v("Loading")])])
}]

export { render, staticRenderFns }